import { computeBalances, toNumber } from "../balances";
import { formatNumber as fmt } from "../format";

export default function BalancesBlock({ balances, payments, templateColumns }) {
  const accounts = balances?.accounts || [];
  const { accountsTotal, deductions, remainder } = computeBalances(balances, payments, templateColumns);

  if (accounts.length === 0 && deductions.length === 0) {
    return null;
  }

  return (
    <div className="balances-block">
      {accounts.length > 0 && (
        <table className="balances-table">
          <thead>
            <tr>
              <th>{balances.date || ""}</th>
              <th>Остаток</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((account) => (
              <tr key={account.id}>
                <td>{account.name}</td>
                <td>{fmt(toNumber(account.amount))}</td>
              </tr>
            ))}
            <tr className="balances-total">
              <td>Итого</td>
              <td>{fmt(accountsTotal)}</td>
            </tr>
          </tbody>
        </table>
      )}

      {deductions.length > 0 && (
        <table className="balances-table">
          <tbody>
            <tr className="balances-total">
              <td>Итого</td>
              <td>{fmt(accountsTotal)}</td>
            </tr>
            {deductions.map((deduction) => (
              <tr key={deduction.id}>
                <td>{deduction.label}</td>
                <td>{deduction.amount ? fmt(deduction.amount) : ""}</td>
              </tr>
            ))}
            <tr className="balances-total">
              <td>Остаток</td>
              <td>{fmt(remainder)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
